import { createSlice } from "@reduxjs/toolkit";
import { DeleteData, EditData } from "./UserReducer";
import { clearErrors, returnErrors } from "./ErrorReducer";
import axios from "axios";
import { toast } from "react-toastify";

let initialState = {
	data: null,
	search: "",
	mainSearch: null,
	isFound: null,
	status: "",
	all: null,
};

export const mathQuizSlice = createSlice({
	name: "mathQuiz",
	initialState,
	reducers: {
		getSearchMathQuiz: (state, { payload }) => {
			state.mainSearch = payload?.data || payload || state?.mainSearch;
			state.isFound = true;
		},
		getSearch: (state, { payload }) => {
			state.search = payload?.search || payload;
		},
		resetMathQuizSearch: state => {
			state.search = "";
			state.mainSearch = null;
			state.isFound = false;
		},
		getMathQuiz: (state, { payload }) => {
			state.data = payload?.data || payload;
		},
		getAllMathQuiz: (state, { payload }) => {
			state.all = payload?.data || payload;
		},
		addMathQuiz: (state, { payload }) => {
			let data = payload?.data || payload;
			state.data = {
				...state?.data,
				docs: state?.data?.docs ? [data, ...state?.data?.docs] : [data],
				totalDocs: state?.data?.totalDocs ? 1 + state?.data?.totalDocs : 1,
			};
			state.all = {
				...state?.all,
				docs: state?.all?.docs ? [data, ...state?.all?.docs] : [data],
				totalDocs: state?.all?.totalDocs ? 1 + state?.all?.totalDocs : 1,
			};
			state.status = "added";
		},
		addMathQuizBatch: (state, { payload }) => {
			let data = payload?.data || payload;
			state.data = {
				...state?.data,
				docs: state?.data?.docs ? [...data, ...state?.data?.docs] : [...data],
				totalDocs: state?.data?.totalDocs
					? data?.length + state?.data?.totalDocs
					: data?.length,
			};
			state.all = {
				...state?.all,
				docs: state?.all?.docs ? [...data, ...state?.all?.docs] : [data],
				totalDocs: state?.all?.totalDocs
					? data?.length + state?.all?.totalDocs
					: data?.length,
			};
			state.status = "added";
		},
		deleteMathQuiz: (state, { payload }) => {
			let data = payload?.data || payload;
			state.status = "deleted";
			state.data = {
				...state?.data,
				docs: DeleteData(state?.data?.docs, data),
				totalDocs: state?.data?.totalDocs ? state?.data?.totalDocs - 1 : 0,
			};
			state.all = {
				...state?.all,
				docs: DeleteData(state?.all?.docs, data),
				totalDocs: state?.all?.totalDocs ? state?.all?.totalDocs - 1 : 0,
			};
		},
		updateMathQuiz: (state, { payload }) => {
			let data = payload?.data || payload;
			state.status = "updated";
			state.data = { ...state?.data, docs: EditData(state?.data?.docs, data) };
			state.all = { ...state?.all, docs: EditData(state?.all?.docs, data) };
		},
		mathQuizFail: state => {
			state.status = "";
			state.isFound = false;
		},
		logoutMathQuiz: state => {
			state.data = null;
			state.search = "";
			state.mainSearch = null;
			state.isFound = null;
			state.all = null;
		},
	},
});
export const {
	mathQuizFail,
	getOrg,
	getMathQuiz,
	deleteMathQuiz,
	addMathQuiz,
	getSearchMathQuiz,
	getSearch,
	resetMathQuizSearch,
	updateMathQuiz,
	logoutMathQuiz,
	getAllMathQuiz,
	addMathQuizBatch
} = mathQuizSlice.actions;

export const manageMathQuiz = (type, data, id) => async dispatch => {
	dispatch(clearErrors());
	try {
		let res;

		if (type === "get") {
			if (data?.search) dispatch(getSearch({ search: data?.search }));
			res = await axios.get(
				`/api/v1/mathQuiz?_populate=category&_populate=subCategory&_populate=image&_populate=language${
					data?.limit ? `&_limit=${data?.limit}` : ""
				}${data?.search ? `&_searchBy=question&_keyword=${data?.search}` : ""}`
			);
			dispatch(
				data?.search ? getSearchMathQuiz(res?.data) : getMathQuiz(res?.data)
			);
			// if (!data) {
			// 	let res2 = await axios.get(
			// 		`/api/v1/mathQuiz?_populate=category&_populate=subCategory&_populate=image&_populate=language&_limit=0`
			// 	);
			// 	dispatch(getAllMathQuiz(res2?.data));
			// }
		}
		if (type === "post") {
			res = await axios.post(`/api/v1/mathQuiz`, { ...data });
			let res2 = await axios.get(
				`/api/v1/mathQuiz/${res?.data?.data?._id}?_populate=category&_populate=subCategory&_populate=image&_populate=language`
			);
			dispatch(addMathQuiz(res2?.data));
		}
		if (type === "batch") {
			res = await axios.post(`/api/v1/mathQuiz/batch`, { ...data });

			dispatch(addMathQuizBatch(res?.data));
		}
		if (type === "put") {
			let newData = data;
			delete newData?._id;
			delete newData?.id;
			res = await axios.put(
				`/api/v1/mathQuiz/${data?._id || data?.id || id}`,
				{
					...newData,
				}
			);
			let res2 = await axios.get(
				`/api/v1/mathQuiz/${res?.data?.data?._id}?_populate=category&_populate=subCategory&_populate=image&_populate=language`
			);
			dispatch(updateMathQuiz(res2?.data));
		}
		if (type === "delete") {
			res = await axios.delete(`/api/v1/mathQuiz/${data?._id}`);
			dispatch(deleteMathQuiz(data));
		}
		if (type !== "get") {
			toast.success(res?.data?.message);
			setTimeout(() => {
				dispatch(mathQuizFail());
			}, 1000);
		}
	} catch (err) {
		if (err) console.log({ error: err.response?.data, err });
		if (err?.response?.status === 429) toast.error(err?.response?.data);
		dispatch(mathQuizFail());
		if (type && type !== "get") {
			let error = err.response?.data?.error;
			if (error) {
				dispatch(returnErrors({ error, status: err?.response?.status }));
			} else {
				toast.error(err?.response?.data?.message);
			}
		}
	}
};
